import Vue from 'vue';
import Router from 'vue-router';
import store from "../store/store";
import Errors from './../../views/Errors.vue';
import Monitor from "./../../views/Monitor";
import stats from "./../../views/Stats";
import report from "./../../views/Reports";
import userProfile from "./../../views/UserProfile";
import configs from "./../../views/Configs";
import login from "./../../views/Login";
import OnlySiloView from "./../../views/OnlySiloView";
import riskAnalysis from "../../views/riskAnalysis";
import app from "./../../views/MainDashboard";
import CotizarSeguro from '../../views/CotizarSeguro.vue';
import routesNames from "./routesNames";

Vue.use(Router);


let router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    linkActiveClass: 'active',
    linkExactActiveClass: 'exact-active',
    scrollBehavior() {
        return {x: 0, y: 0};
    },
    routes: [
        {
            path: '/',
            redirect: '/login',
        },
        {
            path: '/login',
            name: routesNames.LOGIN,
            component: login
        },
        {
            path: '/app',
            name: "app",
            component: app,
            children: [
                {
                    path: '/dashboard',
                    name: routesNames.DASHBOARD,
                    component: Monitor
                },
                {
                    path: '/report',
                    name: routesNames.DAILY_REPORT,
                    component: report
                },
                {
                    path: '/historic',
                    name: routesNames.HISTORICS,
                    component: stats
                },
                {
                    path: '/userprofile',
                    name: routesNames.USER_PROFILE,
                    component: userProfile
                },
                {
                    path: 'risk_analysis',
                    name: routesNames.RISK_ANALYSIS,
                    component: riskAnalysis
                },
                {
                    path: '/configs',
                    name: routesNames.CONFIGS,
                    component: configs
                },
                {
                    path: '/viewsilo',
                    name: routesNames.VIEW_ONLY_SILO,
                    component: OnlySiloView
                },     
                {
                    path: '/insurance',
                    name: routesNames.INSURANCE,
                    component: CotizarSeguro
                }           
            ]
        },
        {
            path: '/errors',
            name: routesNames.ERRORS,
            component: Errors,
        },
        {
            path: '*',
            redirect: '/errors',
        },
    ],

});
router.beforeEach((to, from, next) => {
    if (to.name === routesNames.LOGIN && store.state.token !== undefined) {
        console.info("no voy al login");
        next({name: routesNames.DASHBOARD});
    } else {
        next()
    }
});


export default router;
